import React from 'react'
import { Provider } from 'react-redux'
import { render } from 'react-dom'

const renderContainer = (store, Container) => (props, element) =>
  render(
    <Provider store={store}>
      <Container {...props} />
    </Provider>,
    element
  )

export default renderContainer



// WEBPACK FOOTER //
// ../src/utils/renderContainer.js